import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, Switch, TextField } from '@mui/material';
import { SwiftFlowErrorType } from '@/services/api';

interface CreateValues {
    originalMessage: string;
    code: string;
    gateway: string;
    unifiedMessage: string;
    errorType: SwiftFlowErrorType;
    notify: boolean;
}

interface CreateSwiftFlowErrorDialogProps {
    open: boolean;
    values: CreateValues;
    isCreating: boolean;
    onChange: {
        setOriginalMessage: (value: string) => void;
        setCode: (value: string) => void;
        setGateway: (value: string) => void;
        setUnifiedMessage: (value: string) => void;
        setErrorType: (value: SwiftFlowErrorType) => void;
        setNotify: (value: boolean) => void;
    };
    gateways: string[];
    onSubmit: () => void;
    onClose: () => void;
}

export function CreateSwiftFlowErrorDialog({
    open,
    values,
    isCreating,
    onChange,
    gateways,
    onSubmit,
    onClose,
}: CreateSwiftFlowErrorDialogProps) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Create Swift Flow Error</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Gateway"
                        select
                        fullWidth
                        value={values.gateway}
                        onChange={(e) => onChange.setGateway(e.target.value)}
                        disabled={isCreating}
                    >
                        <MenuItem value="">None</MenuItem>
                        {gateways.map((g) => (
                            <MenuItem key={g} value={g}>
                                {g}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Gateway Error Message"
                        required
                        multiline
                        fullWidth
                        value={values.originalMessage}
                        onChange={(e) => onChange.setOriginalMessage(e.target.value)}
                        disabled={isCreating}
                    />
                    <TextField
                        label="SwiftFlow Error Code"
                        required
                        fullWidth
                        value={values.code}
                        onChange={(e) => onChange.setCode(e.target.value)}
                        disabled={isCreating}
                    />
                    <TextField
                        label="SwiftFlow Unified Error Message"
                        required
                        multiline
                        fullWidth
                        value={values.unifiedMessage}
                        onChange={(e) => onChange.setUnifiedMessage(e.target.value)}
                        disabled={isCreating}
                    />
                    <TextField
                        label="Type"
                        select
                        fullWidth
                        value={values.errorType || 'None'}
                        onChange={(e) => onChange.setErrorType(e.target.value as SwiftFlowErrorType)}
                        disabled={isCreating}
                    >
                        <MenuItem value="Recoverable">Recoverable</MenuItem>
                        <MenuItem value="NonRecoverable">NonRecoverable</MenuItem>
                        <MenuItem value="None">None</MenuItem>
                    </TextField>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={values.notify}
                                onChange={(e) => onChange.setNotify(e.target.checked)}
                                disabled={isCreating}
                            />
                        }
                        label="Notify"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isCreating}>
                    Cancel
                </Button>
                <Button
                    onClick={onSubmit}
                    variant="contained"
                    disabled={isCreating}
                >
                    {isCreating ? 'Creating…' : 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
